<template>
  <a-modal v-bind:open="this.showModal"
           width="600px"
           :closable="true"
           :footer="null"
           :mask-closable="true"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
           @cancel="uiHandler.closeModal"
  >
    <template #title>
      <div class="setting-goal-title-container">
        <a-typography-title :level=4>목표설정</a-typography-title>
      </div>
    </template>
    <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
      <div class="setting-goal-table-container">
        <div class="table-title-container">
          <a-typography-title :level=5 style="margin-left: 5px; margin-bottom: 0px;">{{ selectedYear }} 년</a-typography-title>
          <a-button type="default" @click="uiHandler.onClickButton">{{ editableBtnTxt }}</a-button>
        </div>
        <a-form v-if="editable">
          <a-table bordered
                   :columns="columns"
                   :data-source="dataSource"
                   :pagination="false"
          >
            <template #summary>
              <a-table-summary-row>
                <a-table-summary-cell align="center">
                  <a-typography-text strong>합계</a-typography-text>
                </a-table-summary-cell>
                <a-table-summary-cell align="center">{{ totalGoalAmountTxt }} 원</a-table-summary-cell>
              </a-table-summary-row>
            </template>
          </a-table>

          <div class="submit-container">
            <a-button 
              @click="uiHandler.submitHandler"
              type="primary"
              style="padding: 0 18px;"
            >수정</a-button>
          </div>
        </a-form>
        <a-table v-else
                 bordered
                 :columns="columns"
                 :data-source="dataSource"
                 :pagination="false"
        >
          <template #summary>
            <a-table-summary-row>
              <a-table-summary-cell align="center">
                <a-typography-text strong>합계</a-typography-text>
              </a-table-summary-cell>
              <a-table-summary-cell align="center">{{ totalGoalAmountTxt }} 원</a-table-summary-cell>
            </a-table-summary-row>
          </template>
        </a-table>
      </div>
    </a-row>
  </a-modal>
</template>
<script>
import dayjs from 'dayjs';
import {formatCommaNumber, oneBtnDialog, twoBtnDialog} from "@/utils/utils";
import salesRecordsApi from "@/views/SalesRecordManagement/api";
import {GoalTypes} from "@/views/SalesRecordManagement/enums";

const readOnly = {
  event: {
    CloseModal: "CloseModal"
  },
}

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    type: {
      type: String,
      required: false,
      default: GoalTypes.CONTRACT
    },
  },
  computed: {
    editableBtnTxt() {
      return this.editable ? '수정취소' : '수정'
    },
    totalGoalAmountTxt() {
      return formatCommaNumber(this.totalGoalAmount)
    }
  },
  mounted() {
    this.uiHandler.getGoals()
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      editable: false,
      years: [dayjs().year()], // Initialize with the current year using dayjs
      selectedYear: dayjs().year(), // Initialize with the current year using dayjs

      dataSource: [],
      totalGoalAmount: 0,
      columns: [
        {
          title: '월',
          dataIndex: 'month',
          key: 'month',
          align: 'center',
          customRender: ({text, record}) => {
            return <span>{text}월</span>
          }
        },
        {
          title: '목표금액',
          dataIndex: 'goalAmount',
          key: 'goalAmount',
          align: 'center',
          customRender: ({text, record, index}) => {
            const {dataSource} = this
            if (this.editable) {
              return <a-input-number
                              style={{width: '100%'}}
                              v-model:value={dataSource[index].goalAmount}
                              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              onChange={(e) => {
                                this.dataSource = this.dataSource.map(d => {
                                  if (typeof d.goalAmount === 'string') {
                                    return {...d, goalAmount: parseInt(d.goalAmount)}
                                  } else {
                                    return {...d}
                                  }
                                })
                                this.totalGoalAmount = this.dataSource.map(d => d.goalAmount).reduce((c, t) => c + t, 0)
                              }}
              />
            } else {
              return <span>{formatCommaNumber(text)} 원</span>
            }
          }
        },
      ],
    }
  },
  methods: {
    ui() {
      return {
        closeModal: () => {
          this.editable = false;
          this.$emit(readOnly.event.CloseModal, {
            ModalStatus: false
          });
        },
        submitHandler: async (params) => {
          const confirm = await twoBtnDialog('알림', `${this.selectedYear}년 목표금액을 수정하시겠습니까?`)
          if (!confirm) {
            return
          }

          await this.apiHandler.updateGoals({
                year: this.selectedYear,
                type: this.type,
                goals: this.dataSource.map(d => {
                  return {month: d.month, goalAmount: d.goalAmount}
                })
              },
              async (r) => {
                await oneBtnDialog('알림', `${this.selectedYear}의 목표금액을 수정하였습니다.`).then(() => {
                  this.editable = false
                })
              },
              (e) => {
                console.log("error=>", e)
              })
        },
        onClickButton: (e) => {
          this.editable = !this.editable
          this.uiHandler.getGoals();
        },
        getGoals: async () => {
          const years = this.years
          await this.apiHandler.getGoals({years: [...years], type: this.type}, (response) => {
            // 해당 연도 목표가 아직 등록되지 않은 계정이면 서버가 빈 목록을 준다.
            // 예전에는 filter(...)[0] 이 undefined 인 채로 .goals 를 읽어 화면이 통째로 죽었다.
            // 목표를 아직 안 만든 계정은 정상 상태이므로, 빈 표를 보여 주고 등록할 수 있게 둔다.
            const current = (response.data || []).filter(item => years.includes(item.year))[0]
            const goals = current?.goals ?? []

            this.totalGoalAmount = goals.map(g => g.goalAmount).reduce((t, c) => t + c, 0).toLocaleString()
            this.dataSource = goals.map(g => {
              return {...g, goalAmountTxt: g.goalAmount.toLocaleString()}
            })
          }, (error) => {
            console.error(error)
          })
        },
      }
    },
    api() {
      return salesRecordsApi(this.$apiInstance, this.$store)
    },
  }
}
</script>
<style scoped>
.setting-goal-title-container {
  padding: 15px 0 5px 10px
}

.setting-goal-table-container {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.table-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.submit-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
</style>
